var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0C25.671 0 19.4841 1.87677 14.2218 5.39297C8.95939 8.90918 4.85787 13.9069 2.43587 19.7541C0.0138652 25.6014 -0.619842 32.0355 0.614885 38.2429C1.84961 44.4503 4.89732 50.1521 9.3726 54.6274C13.8479 59.1027 19.5497 62.1504 25.7571 63.3851C31.9645 64.6198 38.3987 63.9861 44.2459 61.5641C50.0931 59.1421 55.0908 55.0406 58.607 49.7782C62.1232 44.5159 64 38.329 64 32C64 23.5131 60.6286 15.3737 54.6274 9.37258C48.6263 3.37142 40.4869 0 32 0ZM40.7067 43.36C41.4938 43.9582 42.0125 44.8433 42.1499 45.8223C42.2872 46.8013 42.0321 47.7949 41.44 48.5867C41.0847 49.0392 40.6313 49.4052 40.1139 49.6569C39.5965 49.9087 39.0287 50.0397 38.4533 50.04C37.6498 50.0535 36.8637 49.8055 36.2133 49.3333L17.3333 34.96C16.8774 34.6129 16.5078 34.1652 16.2533 33.6518C15.9989 33.1383 15.8665 32.573 15.8665 32C15.8665 31.427 15.9989 30.8617 16.2533 30.3482C16.5078 29.8348 16.8774 29.3871 17.3333 29.04L36.2133 14.6667C37.0002 14.0708 37.9914 13.8119 38.9691 13.9469C39.9468 14.082 40.8308 14.5999 41.4267 15.3867C42.0225 16.1735 42.2814 17.1648 42.1464 18.1424C42.0114 19.1201 41.4935 20.0041 40.7067 20.6L25.7333 32L40.7067 43.36Z",
    fill: "#3B2D41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextarrow);
export default __webpack_public_path__ + "static/media/next.arrow.96070f082fdec2e957473233db158b47.svg";
export { ForwardRef as ReactComponent };